import createClient from '../../apolloClient';
import MUTATION_COMPLETE_PASSWORD from '../../mutation/completePassword';

const handleCompletePassword = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_COMPLETE_PASSWORD,
    variables,
  });
  const { completePassword } = result?.data || {};
  return completePassword;
};

export default handleCompletePassword;
